/* Copyright (c) 2022 Paul Nebel */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import LogoSmall from './logo-small';

const LogoSmallIcon = styled(LogoSmall)` 
    width: 30px; 
    height: 30px;
`;

function CFModal({ modalClass, handleModalClassChanged, title, children }) {
    const [state, setState] = useState({
        modalClass,
    });

    React.useEffect(
        () => setState(prevState => {
            return {
                ...prevState,
                modalClass,
            };
        }),
        [modalClass],
    );

    return (
        <div className={ state.modalClass }>
            <div className='modal-background'></div>
            <div className='modal-card'>
                <header className='modal-card-head'>
                    <LogoSmallIcon color='#dee5ed' className='pr-3' />
                    <p className='modal-card-title pl-1'>
                        { title }
                    </p>
                    <button
                        className='delete is-large'
                        aria-label='close'
                        onClick={ () => {
                            handleModalClassChanged('modal');
                            return false;
                        } }
                    ></button>
                </header>
                <section className='modal-card-body'>
                    { children }
                </section>
                <footer className='modal-card-foot'>
                    <p>&copy; 2022 DogFish Music Ltd.</p>
                </footer>
            </div>
        </div>
    );
}

CFModal.propTypes = {
    modalClass: PropTypes.string,
    handleModalClassChanged: PropTypes.func,
    title: PropTypes.string,
    children: PropTypes.element.isRequired,
};

CFModal.defaultProps = {
    modalClass: 'modal',
    title: 'Title',
    handleModalClassChanged: () => { /* do nothing */ },
};

export default CFModal;